import { BulkActionStateEnum } from 'owa-bulk-action-store';
import { store as bulkActionStore } from 'owa-bulk-action-store';
import { RuleBulkActionCustomData } from '../orchestrators/runRuleNowOrchestrator';

export default function isRuleRunning(ruleId: string, folderId: string) {
    const runningBulkActionInfo = bulkActionStore.bulkActionInformationMap.get(folderId);

    if (!runningBulkActionInfo) {
        return false;
    }

    const currentState = runningBulkActionInfo.state;
    const ruleBulkActionCustomData: RuleBulkActionCustomData =
        runningBulkActionInfo.customData && JSON.parse(runningBulkActionInfo.customData);
    const scenario = ruleBulkActionCustomData
        ? ruleBulkActionCustomData.Scenario
        : runningBulkActionInfo.class;

    return (
        (currentState == BulkActionStateEnum.Uninitialized ||
            currentState == BulkActionStateEnum.Running) &&
        scenario == 'RunRuleNow' &&
        ruleBulkActionCustomData.ruleId == ruleId
    );
}
